import React from 'react';

import './racePagination.css';

interface RacePaginationProps {
	maxPages: number | null
	currentPage: number
	setCurrentPage: (page: number) => void
	raceType: string
}

export default function RacePagination({maxPages, currentPage, setCurrentPage, raceType}: RacePaginationProps){

	const handleClick = (pageNum: number) => {
		if(pageNum >= 1 && pageNum <= maxPages!){
			setCurrentPage(pageNum);
		}
	}

	if(maxPages === null || maxPages === 0){
		return <div className='racePagination'>Loading...</div>
	}

	const getPageNumbers = () => {
		const pages: (number | string)[] = [];
		const totalPages = maxPages!;
		
		if(totalPages <= 7){
			for(let i = 1; i <= totalPages; i++){
				pages.push(i);
			}
		} else {
			pages.push(1);
			
			if(currentPage <= 3){
				for(let i = 2; i <= 4; i++){
					pages.push(i);
				}
				pages.push('ellipsis-end');
				pages.push(totalPages);
			} else if(currentPage >= totalPages - 2){
				pages.push('ellipsis-start');
				for(let i = totalPages - 3; i <= totalPages; i++){
					pages.push(i);
				}
			} else {
				pages.push('ellipsis-start');
				for(let i = currentPage - 1; i <= currentPage + 1; i++){
					pages.push(i);
				}
				pages.push('ellipsis-end');
				pages.push(totalPages);
			}
		}
		
		return pages;
	}

	const pageNumbers = getPageNumbers();

	return <div className='racePagination'>
		<div className='racePaginationPages'>
			{pageNumbers.map((page, index) => {
				if(page === 'ellipsis-start' || page === 'ellipsis-end'){
					return <span key={`ellipsis-${index}`} className='racePaginationEllipsis'>...</span>;
				}
				const pageNum = page as number;
				return (
					<button
						key={pageNum}
						className={`racePaginationPage ${pageNum === currentPage ? 'currentPage' : ''}`}
						onClick={() => handleClick(pageNum)}
						aria-label={`Page ${pageNum}`}
						aria-current={pageNum === currentPage ? 'page' : undefined}
					>
						{pageNum}
					</button>
				);
			})}
		</div>
		<div className='racePaginationPrevNext'>
			<button
				className='racePaginationButton'
				onClick={() => handleClick(currentPage - 1)}
				disabled={currentPage === 1}
				aria-label="Previous page"
			>
				Previous
			</button>
			<button
				className='racePaginationButton'
				onClick={() => handleClick(currentPage + 1)}
				disabled={currentPage === maxPages}
				aria-label="Next page"
			>
				Next
			</button>
		</div>
	</div>
};